import './app.module.scss';
import 'box-ui-elements/es/styles/base.scss';
import { TooltipProvider, Notification } from '@box/blueprint-web';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import get from 'lodash/get';
import FeatureProvider from 'box-ui-elements/es/elements/common/feature-checking/FeatureProvider';
import * as CurrentUser from '../../common/current-user';
import { SubmissionPageContainer } from '../submission-page/submission-page-container';
import { PAGE_NAME } from '../form-submitter/form-submitter-context/form-submitter-constant';
import getLocale from './app-locale';
import ResinApplication from '../../common/utils/resin/components/ResinApplication';
import {
  SplitTreatmentProvider,
  defaultUseTreatmentOn,
} from '../../common/split-treatment';
import ResinPage from '../../common/utils/resin/components/ResinPage';
import UserAPI from '../../api/User';
import { setResponseInterceptor } from '../../common/http/lib';
import LoadingFormPage from '../submission-page/loading-form-page';
import Internationalize from '../intl';

const renderSubmissionPage = () => (
  <ResinPage pageName={PAGE_NAME}>
    <SubmissionPageContainer />
  </ResinPage>
);

const App = () => {
  const [{ currentUser, isLoading }, setState] = useState({
    currentUser: CurrentUser.defaultValue,
    isLoading: true,
  });
  const relayFeatures = get(currentUser, 'relayFeatures', {});

  useEffect(() => {
    const fetchCurrentUser = async () => {
      const user = await UserAPI.getCurrentUser();
      const { accountHost } = user;
      setResponseInterceptor({ accountHost });
      setState({ currentUser: user, isLoading: false });
    };
    fetchCurrentUser();
  }, []);

  if (isLoading) {
    return (
      <Internationalize language={getLocale()}>
        <LoadingFormPage />
      </Internationalize>
    );
  }

  return (
    <Internationalize language={getLocale()}>
      <ResinApplication applicationName="form-submitter">
        <FeatureProvider features={relayFeatures}>
          <SplitTreatmentProvider useTreatmentOn={defaultUseTreatmentOn}>
            <CurrentUser.Provider value={currentUser}>
              <TooltipProvider>
                <Notification.Provider>
                  {/*
                   // @ts-expect-error [MIGRATION-SUPPRESSION]: TS2786 */}
                  <Router>
                    {/*
                     // @ts-expect-error [MIGRATION-SUPPRESSION]: TS2786 */}
                    <Switch>
                      {/*
                       // @ts-expect-error [MIGRATION-SUPPRESSION]: TS2786 */}
                      <Route
                        component={renderSubmissionPage}
                        exact
                        path="/f/:urlId"
                      />
                      {/*
                       // @ts-expect-error [MIGRATION-SUPPRESSION]: TS2786 */}
                      <Route component={renderSubmissionPage} />
                    </Switch>
                  </Router>
                  <Notification.Viewport />
                </Notification.Provider>
              </TooltipProvider>
            </CurrentUser.Provider>
          </SplitTreatmentProvider>
        </FeatureProvider>
      </ResinApplication>
    </Internationalize>
  );
};

export { App };
export default App;
